import { action, payload } from "ts-action";
import {
  ColorCategories,
  TableCells,
  TableColumns,
  TableRow,
  TableRowAllowSettings,
} from "../../requests/table/types";
import { TableIdentifier } from "./types";

// Table data fetch

export const tableRequestPages = action(
  "TABLE DATA :: FETCH PAGES > REQUEST",
  payload<
    TableIdentifier & {
      pages: number[];
      fetchParamsHash: string;
      isOldDataObsolete: boolean;
      isPrefetch: boolean;
    }
  >()
);

export const tableReceivePages = action(
  "TABLE DATA :: FETCH PAGES > RECEIVE",
  payload<
    TableIdentifier & {
      columns: TableColumns;
      pages: number[]; // pole pageNr, pro které jsem dělal request. Teoreticky se nemusí shodovat s Object.keys(pagesByPageNumber) - například kdyby neexistovala některá ze stránek, o kterou jsem si řekl.
      pagesByPageNumber: { [pageNumber: number]: TableRow[] };
      totalRowCount: number;
      rowsPerPage: number;
      allowSettings: TableRowAllowSettings;
      colorCategories: ColorCategories;
    }
  >()
);

export const tableErrorWhenFetchingPages = action(
  "TABLE DATA :: FETCH PAGES > ERROR",
  payload<TableIdentifier & { pages: number[] }>()
);

export const tableRequestFirstNRows = action(
  "TABLE DATA :: FETCH FIRST N ROWS > REQUEST",
  payload<TableIdentifier & { numberOfRows: number; fetchParamsHash: string }>()
);

export const tableReceiveFirstNRows = action(
  "TABLE DATA :: FETCH FIRST N ROWS > RECEIVE",
  payload<
    TableIdentifier & {
      columns: TableColumns;
      rows: TableRow[];
      totalRowCount: number;
      allowSettings: TableRowAllowSettings;
      colorCategories: ColorCategories;
    }
  >()
);

export const tableErrorWhenFetchingFirstNRows = action(
  "TABLE DATA :: FETCH FIRST N ROWS > ERROR",
  payload<TableIdentifier & { numberOfRows: number }>()
);

// Rows per page + current page

export const tableChangeRowsPerPage = action(
  "TABLE DATA :: CHANGE ROWS PER PAGE",
  payload<TableIdentifier & { rowsPerPage: number }>()
);

export const tableChangeCurrentPage = action(
  "TABLE DATA :: CHANGE CURRENT PAGE",
  payload<TableIdentifier & { currentPage: number }>()
);

export const tableDropPaging = action(
  "TABLE DATA :: DROP PAGING",
  payload<TableIdentifier>()
);

// Edit row fetch

export const tableRequestEditableRow = action(
  "TABLE DATA :: EDITABLE ROW > FETCH > REQUEST",
  payload<TableIdentifier & { rowHash: string }>()
);

export const tableReceiveEditableRow = action(
  "TABLE DATA :: EDITABLE ROW > FETCH > RECEIVE",
  payload<
    TableIdentifier & {
      rowHash: string;
      row: TableRow;
      columns: TableColumns;
    }
  >()
);

export const tableErrorEditableRow = action(
  "TABLE DATA :: EDITABLE ROW > FETCH > ERROR",
  payload<TableIdentifier & { rowHash: string; error: string }>()
);

// Edit row submit

export const tableRequestEditableRowSubmit = action(
  "TABLE DATA :: EDITABLE ROW > SUBMIT > REQUEST",
  payload<TableIdentifier & { rowHash: string }>()
);

export const tableReceiveEditableRowSubmit = action(
  "TABLE DATA :: EDITABLE ROW > SUBMIT > RECEIVE",
  payload<TableIdentifier & { rowHash: string }>()
);

export const tableErrorEditableRowSubmit = action(
  "TABLE DATA :: EDITABLE ROW > SUBMIT > ERROR",
  payload<TableIdentifier & { rowHash: string; error: string }>()
);

// Empty fetch

export const tableRequestEmptyRow = action(
  "TABLE DATA :: EMPTY ROW > FETCH > REQUEST",
  payload<TableIdentifier>()
);

export const tableReceiveEmptyRow = action(
  "TABLE DATA :: EMPTY ROW > FETCH > RECEIVE",
  payload<
    TableIdentifier & {
      row: TableRow;
      columns: TableColumns;
    }
  >()
);

export const tableErrorEmptyRow = action(
  "TABLE DATA :: EMPTY ROW > FETCH > ERROR",
  payload<TableIdentifier & { error: string }>()
);

// Submit new row

export const tableRequestEmptyRowSubmit = action(
  "TABLE DATA :: NEW ROW > SUBMIT> REQUEST",
  payload<TableIdentifier & { cells: TableCells }>()
);

export const tableReceiveEmptyRowSubmit = action(
  "TABLE DATA :: NEW ROW > SUBMIT> RECEIVE",
  payload<TableIdentifier & { cells: TableCells }>()
);

export const tableErrorEmptyRowSubmit = action(
  "TABLE DATA :: NEW ROW > SUBMIT> ERROR",
  payload<TableIdentifier & { cells: TableCells; error: string }>()
);

export const relocalizeAdminTableHeaders = action(
  "TABLE DATA :: ADMINISTRATION > RELOCALIZE HEADERS",
  payload<void>()
);
